export default 
{
	"progressbar-page-title": "Page",
	"name-suffix": "Suffix",
	"fileupload-desc-progress-message": "Uploading {progress}",
	"required-if-greater-than-or-equal": "{property} is required when {compareSource} is greater than or equal to {compareValue}.",
	"powered-by-cognito": "Powered by Cognito Forms.",
	"form-name-default": "Untitled",
	"field-choice-defaults": "First Choice|Second Choice|Third Choice",
	"additional-fee-default-label": "Additional Fee",
	"authenticated-save-and-resume-email-dialog": "Email a link and return to your form to complete your submission.",
	"string-length-between": "{property} must be between {min} and {max} characters.",
	"update-button-text": "Update",
	"address-zip-code-invalid": "Zip Code must be formatted as #####-####.",
	"required-if-greater-than": "{property} is required when {compareSource} is greater than {compareValue}.",
	"compare-before": "{property} must be before {compareSource}.",
	"compare-after": "{property} must be after {compareSource}.",
	"unsupported-browser-message": "Oh No! You are using an unsupported browser. {a}Click Here{/a} to upgrade.",
	"shared-entry-email-subject": "Shared Link",
	"send-button-text": "Send",
	"venmo-help-text": "Connect to Venmo to continue with payment.",
	"field-repeatingsection-item-label": "Item",
	"save-and-resume-email-not-sent-message": "There was a problem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} must be at least {min}.",
	"entry-notification-full-entry-detail-link": "View full entry details at cognitoforms.com.",
	"element-label-website": "Website",
	"element-label-signature": "Signature",
	"paypal-help-text": "Connect to PayPal to continue with payment.",
	"card-on-file-agreement-validation": "You must agree to save your card for future transactions.",
	"marketing-button-4": "Build Your Own for Free",
	"field-datepicker-now": "Now",
	"save-and-resume-email-resume-button": "Resume Now",
	"field-datepicker-next-month": "Next Month",
	"quantity-remaining-text": "remaining",
	"payment-declined": "Payment Declined",
	"required-if-before": "{property} is required when {compareSource} is before {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} must be less than {compareSource}.",
	"entry-admin-link": "Admin Link",
	"required-many": "{0} are required.",
	"save-and-resume-multiple-days-expiration-email-message": "Use the link below to return to your form within the next {days} days to complete your submission.",
	"string-length-at-least": "{property} must be at least {min} characters.",
	"credit-card-number": "Credit Card Number",
	"range-on-or-before": "{property} must be on or before {max}.",
	"required-one": "{0} is required.",
	"fileupload-max-file-count-exceeded-message": "Only {maxFileCount} files may be uploaded.",
	"order-transaction-details-header": "Transaction Details",
	"field-spinner-increase": "Increase",
	"payment-processing-fees": "Processing Fees",
	"payment": "Payment",
	"field-choice-other-fill-in": "Other",
	"shared-entry-email-message": "An entry has been shared with you.",
	"shared-entry-workflow-link": "View the form.",
	"required-if-exists": "{property} is required when {compareSource} is specified.",
	"concurrent-conflict-toast-message": "Your submission was unsuccessful because information on this form has changed. Please review and try again.",
	"secured-by-paypal": "Secured by",
	"range-on-or-after": "{property} must be on or after {min}.",
	"payment-amount-due": "Amount Due",
	"required-name-first-and-last": "First and Last are required.",
	"required": "{property} is required.",
	"string-format-alphabetic": "{property} must only contain letters.",
	"quantity-limit": "{property} quantity exceeded.",
	"field-spinner-decrease": "Decrease",
	"field-repeatingsection-add-link-text": "Add",
	"fileupload-max-size-exceeded-message": "Only files smaller than {maxSize} MB may be uploaded.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Not Captured",
	"field-ratingscale-satisfied-unsatisfied-label": "Satisfied/Unsatisfied",
	"range-between": "{property} must be between {min} and {max}.",
	"field-ratingscale-agree-disagree-label": "Agree/Disagree",
	"back-button-text": "Back",
	"address-country": "Country",
	"order-not-found": "No order information found.",
	"field-ratingscale-satisfied-unsatisfied-options": "Very Unsatisfied|Unsatisfied|Neutral|Satisfied|Very Satisfied",
	"entry-notification-entry-details-header": "Entry Details",
	"FALSE": "FALSE",
	"compare-greater-than-or-equal": "{property} must be greater than or equal to {compareSource}.",
	"receipt-notification-order-details-desc-header": "Description",
	"order-method-label": "Method",
	"order-total-label": "Order Total",
	"invalid-shared-link": "Invalid Shared Link",
	"fileupload-zero-byte-file-message": "Zero byte files may not be uploaded.",
	"range-at-most": "{property} must be at most {max}.",
	"format-integer": "####",
	"order-date-label": "Date",
	"fileupload-dropzone-message": "or drag files here.",
	"shared-entry-view-link": "View the shared entry.",
	"format-currency": "$#,###.##",
	"string-length-at-most": "{property} must be at most {max} characters.",
	"entry-confirmation-footer-tagline": "Create your own powerful payment forms with",
	"submit-button-text": "Submit",
	"marketing-msg": "Easily create powerful forms.",
	"required-if-on-or-after": "{property} is required when {compareSource} is on or after {compareValue}.",
	"card-on-file-agreement": "I agree to save my card and allow {orgname} to charge it for future payments in accordance with their terms.",
	"signature-draw": "draw",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} must be on or after {compareSource}.",
	"required-if-less-than-or-equal": "{property} is required when {compareSource} is less than or equal to {compareValue}.",
	"field-datepicker-next-year": "Next Year",
	"change-button": "change",
	"fileupload-desc-size-in-bytes-message": "{size} bytes",
	"card-tab": "Card",
	"order-billing-info-header": "Billing Info",
	"entry-email-view-details-text": "View full entry at CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Use the link below to return to your form within the next day to complete your submission.",
	"credit-card-authentication-failed": "Card failed authentication.",
	"compare-less-than-or-equal": "{property} must be less than or equal to {compareSource}.",
	"receipt-notification-order-details-balance-due": "Balance Due",
	"save-and-resume-multiple-days-expiration-message": "Copy or email the link below and return to your form within the next {days} days to complete your submission.",
	"processing-fee-calculating-message": "Calculating",
	"receipt-notification-trx-details-method": "Method",
	"field-choice-no-match": "No matching options",
	"fileupload-invalid-file-type-message": "Only {allowedTypes} files may be uploaded.",
	"receipt-notification-trx-details-date": "Date",
	"credit-card-authorization": "Card Authorization",
	"address-line1": "Address Line 1",
	"required-if-not-exists": "{property} is required when {compareSource} is not specified.",
	"required-if-not-equal": "{property} is required when {compareSource} is not {compareValue}.",
	"marketing-button-2": "Build Your Own for Free",
	"receipt-notification-billing-info-header": "Billing Info",
	"required-if-after": "{property} is required when {compareSource} is after {compareValue}.",
	"element-label-name": "Name",
	"required-if-equal": "{property} is required when {compareSource} is {compareValue}.",
	"connected-to-paypal": "Connected to PayPal.",
	"people-form-email-quantity-exceeded-message": "Email address must be unique.",
	"receipt-notification-order-details-subtotal": "Subtotal",
	"shared-entry-edit-link": "Edit the shared entry.",
	"receipt-notification-trx-details-header": "Transaction Details",
	"address-city": "City",
	"receipt-notification-order-details-amount-paid": "Amount Paid",
	"credit-card-invalid": "Card is invalid.",
	"format-decimal": "####.##",
	"entry-notification-new-submission-text": "You have a new form submission.",
	"this-and-that": "{0} and {1}",
	"field-ratingscale-good-poor-label": "Good/Poor",
	"network-unavailable-message": "Network unavailable, please try again later.",
	"dialog-close": "Close",
	"string-format-alphanumeric": "{property} must only contain letters and numbers.",
	"credit-card": "Credit Card",
	"remove-item": "Remove {item}",
	"receipt-notification-order-details-price-header": "Price",
	"fileupload-upload-inprogress-message": "File upload in progress.",
	"public-terms-of-service-link-text": "Terms of Service",
	"save-and-resume-email-subject": "Save \u0026 Resume Link",
	"field-repeatingsection-remove-link-text": "Remove",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Add {item}",
	"field-toggle-options": "Yes/No|True/False|Open/Closed|Active/Inactive|Read/Unread",
	"order-submit-timeout": "Order processing is taking too long. Please try your order later.",
	"listlength-at-most": "Please specify no more than {max} {property}.",
	"shared-entry-email-view-message": "Use the link below to view the shared entry.",
	"order-number-label": "Number",
	"card-declined": "Card Declined",
	"fileupload-default-upload-button-text": "Upload",
	"name-prefix": "Title",
	"address-line2": "Address Line 2",
	"element-label-email": "Email",
	"field-ratingscale-good-poor-options": "Very Poor|Poor|Average|Good|Very Good",
	"next-button-text": "Next",
	"question": "Question",
	"address-postalcode": "Postal / Zip Code",
	"format-with-description": "{property} must be formatted as {description}.",
	"field-datepicker-prev-month": "Previous Month",
	"name": "Name",
	"receipt-notification-order-details-total-footer": "Total",
	"confirmation-message": "Thank you for filling out the form. Your response has been recorded.",
	"shared-entry-email-edit-message": "Use the link below to edit the shared entry.",
	"field-default-label": "Untitled",
	"required-value": "{property} must be {value}.",
	"name-middle": "Middle",
	"fileupload-failed-upload-message": "{fileName} failed to upload.",
	"shared-entry-email-button-label": "View Entry",
	"field-datepicker-year": "",
	"element-label-phone": "Phone",
	"TRUE": "TRUE",
	"listlength-between": "Please specify between {min} and {max} {property}.",
	"marketing-button-1": "Try It Now",
	"entry-submission-error-heading": "Error processing entry",
	"order-not-found-message": "No order information found.",
	"format-without-description": "{property} is not properly formatted.",
	"name-last": "Last",
	"field-ratingscale-one-five-label": "Scale of 1 to 5",
	"listlength-at-least": "Please specify at least {min} {property}.",
	"united-states": "United States",
	"field-signature-captured": "Captured",
	"compare-on-or-before": "{property} must be on or before {compareSource}.",
	"order-balance-due-label": "Balance Due",
	"required-if-less-than": "{property} is required when {compareSource} is less than {compareValue}.",
	"credit-card-postalcode": "Postal Code",
	"form-not-available-message": "This form is not currently available.",
	"element-label-address": "Address",
	"receipt-notification-trx-details-number": "Number",
	"public-submission-warning": "Please do not submit passwords through Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Use the link below to return to your form to complete your submission.",
	"fileupload-excluded-file-type-message": "Files of this type may not be uploaded.",
	"payment-subtotal": "Subtotal",
	"collapse": "Collapse",
	"save-button-text": "Save",
	"field-datepicker-prev-year": "Previous Year",
	"signature-type": "type",
	"order-amount-minimum": "Amount Due must be at least $1.00.",
	"string-format-numeric": "{property} must only contain numbers.",
	"entry-confirmation-entry-details-header": "Entry Details",
	"connected-to-venmo": "Connected to Venmo.",
	"format-percentage": "#.##%",
	"receipt-notification-header": "Receipt",
	"clear": "Clear",
	"today": "Today",
	"required-name-last": "Last is required.",
	"marketing-button-3": "Try It Now",
	"expand": "Expand",
	"compare-greater-than": "{property} must be greater than {compareSource}.",
	"field-ratingscale-will-wont-label": "Will/Won\u0027t",
	"required-name-first": "First is required.",
	"save-and-resume-one-day-expiration-message": "Copy or email the link below and return to your form within the next day to complete your submission.",
	"required-asterisk": "required",
	"credit-card-required": "Credit Card is required.",
	"address-state-province-region": "State / Province / Region",
	"save-and-resume-email-sent-message": "The email has been sent.",
	"workflow-action": "Action",
	"field-ratingscale-will-wont-options": "Definitely Won\u0027t|Probably Won\u0027t|Not Sure|Probably Will|Definitely Will",
	"save-and-resume-email-label": "Email me my link:",
	"field-ratingscale-agree-disagree-options": "Strongly Disagree|Disagree|Neutral|Agree|Strongly Agree",
	"order-exception-order-already-paid": "This order has already been paid.",
	"fileupload-download-text": "Download",
	"address-state": "State",
	"allowed-values": "{property} is not in the list of allowed values.",
	"shared-entry-workflow-email-button-label": "Open Form",
	"compare-equal": "{property} must be the same as {compareSource}.",
	"field-datepicker-clear": "Clear",
	"name-first": "First",
	"save-and-resume-message": "Your progress has been saved.",
	"save-and-resume-no-expiration-message": "Copy or email the link below and return to your form to complete your submission.",
	"entry-notification-view-details-text": "View Details",
	"order-exception-default-message": "Unable to process transaction.",
	"public-report-abuse-link-text": "Report Abuse",
	"order-amount-paid": "Amount Paid",
	"element-label-default": "Untitled",
	"countries": "Afghanistan|Albania|Algeria|American Samoa|Andorra|Angola|Anguilla|Antarctica|Antigua and Barbuda|Argentina|Armenia|Aruba|Australia|Austria|Azerbaijan|Bahamas|Bahrain|Bangladesh|Barbados|Belarus|Belgium|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia and Herzegovina|Botswana|Brazil|Brunei Darussalam|Bulgaria|Burkina Faso|Burundi|Cambodia|Cameroon|Canada|Cape Verde|Cayman Islands|Central African Republic|Chad|Chile|China|Christmas Island|Cocos (Keeling) Islands|Colombia|Comoros|Congo, Republic of the (Brazzaville)|Cook Islands|Costa Rica|Croatia|Cuba|Curaçao|Cyprus|Czech Republic|Democratic Republic of the Congo (Kinshasa)|Denmark|Djibouti|Dominica|Dominican Republic|East Timor (Timor-Leste)|Ecuador|Egypt|El Salvador|Equatorial Guinea|Eritrea|Estonia|Ethiopia|Falkland Islands|Faroe Islands|Fiji|Finland|France|French Guiana|French Polynesia|French Southern Territories|Gabon|Gambia|Georgia|Germany|Ghana|Gibraltar|Great Britain|Greece|Greenland|Grenada|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Holy See|Honduras|Hong Kong|Hungary|Iceland|India|Indonesia|Iran (Islamic Republic of)|Iraq|Ireland|Isle of Man|Israel|Italy|Ivory Coast|Jamaica|Japan|Jordan|Kazakhstan|Kenya|Kiribati|Korea, Democratic People\u0027s Rep. (North Korea)|Korea, Republic of (South Korea)|Kosovo|Kuwait|Kyrgyzstan|Lao, People\u0027s Democratic Republic|Latvia|Lebanon|Lesotho|Liberia|Libya|Liechtenstein|Lithuania|Luxembourg|Macau|North Macedonia, Rep. of|Madagascar|Malawi|Malaysia|Maldives|Mali|Malta|Marshall Islands|Martinique|Mauritania|Mauritius|Mayotte|Mexico|Micronesia, Federated States of|Moldova, Republic of|Monaco|Mongolia|Montenegro|Montserrat|Morocco|Mozambique|Myanmar, Burma|Namibia|Nauru|Nepal|Netherlands|Netherlands Antilles|New Caledonia|New Zealand|Nicaragua|Niger|Nigeria|Niue|Northern Mariana Islands|Norway|Oman|Pakistan|Palau|Palestinian territories|Panama|Papua New Guinea|Paraguay|Peru|Philippines|Pitcairn Island|Poland|Portugal|Puerto Rico|Qatar|Reunion Island|Romania|Russian Federation|Rwanda|Saint Kitts and Nevis|Saint Lucia|Saint Vincent and the Grenadines|Samoa|San Marino|Sao Tome and Principe|Saudi Arabia|Senegal|Serbia|Seychelles|Sierra Leone|Singapore|Slovakia (Slovak Republic)|Slovenia|Solomon Islands|Somalia|South Africa|South Sudan|Spain|Sri Lanka|Sudan|Suriname|Swaziland|Sweden|Switzerland|Syria (Syrian Arab Republic)|Taiwan (Republic of China)|Tajikistan|Tanzania; officially the United Republic of Tanzania|Thailand|Tibet|Timor-Leste (East Timor)|Togo|Tokelau|Tonga|Trinidad and Tobago|Tunisia|Türkiye|Turkmenistan|Turks and Caicos Islands|Tuvalu|Uganda|Ukraine|United Arab Emirates|United Kingdom|United States|Uruguay|Uzbekistan|Vanuatu|Vatican City State (Holy See)|Venezuela|Vietnam|Virgin Islands (British)|Virgin Islands (U.S.)|Wallis and Futuna Islands|Western Sahara|Yemen|Zambia|Zimbabwe",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Order must contain at least 1 line item.",
	"compare-not-equal": "{property} must be different from {compareSource}.",
	"entry-notification-footer": "You are receiving this email because you selected the receive email notifications option on your form in Cognito Forms.",
	"save-and-resume-copy-link-label": "Copy your form link:",
	"entry-confirmation-footer": "You are receiving this email because you completed a transaction with [Name].",
	"required-if-on-or-before": "{property} is required when {compareSource} is on or before {compareValue}.",
	"string-format": "{property} must be formatted as {formatDescription}.",
	"switch-to-drawing-mode": "Switch to drawing mode from type mode.",
	"switch-to-typing-mode": "Switch to typing mode from draw mode.",
	"signature-present": "Signature is present",
	"signature-drawing-area": "Signature drawing area",
	"payment-below-minimum": "This form cannot accept payments for orders less than {amount}.",
	"payment-account-unavailable": "This form is not able to accept payments right now. Please contact {orgname}.",
	"payment-processing-fees-international": "International Processing Fees",
	"continue-button-text": "Continue",
	"doc-sign-print": "Print",
	"doc-sign-zoom-out": "Zoom out",
	"doc-sign-zoom-percent": "{zoom}%",
	"doc-sign-zoom-in": "Zoom in",
	"doc-sign-documents": "Documents",
	"file-viewer-download-file": "Download file",
	"file-viewer-previous-file": "Previous file",
	"doc-sign-zoom-level": "Zoom level {zoom}%",
	"file-viewer-filter-other": "Other",
	"file-viewer-cannot-render": "{file} can’t be rendered inline.",
	"file-viewer-filter-images": "Images",
	"file-viewer-filter-documents": "Documents",
	"file-viewer-too-large": "{file} is too large to preview inline.",
	"doc-sign-page-of": "Page {page} of {pages}",
	"doc-sign-zoom-reset": "Reset zoom",
	"file-viewer-load-error": "{file} couldn’t be loaded inline.",
	"file-viewer-loading": "Loading file preview",
	"file-viewer-files": "Files",
	"file-viewer-preview-unavailable": "Preview unavailable",
	"file-viewer-filter-all": "All",
	"file-viewer-next-file": "Next file",
	"fileupload-max-file-count-exceeded-message-singular": "Only {maxFileCount} file may be uploaded.",
	"document-field-preview": "Preview",
	"file-viewer-generating": "Generating {file}…",
	"file-viewer-generation-failed": "{file} couldn’t be generated.",
	"file-viewer-try-again": "Try again",
	"saved-card-ending-in": "Card ending in {last4}",
	"saved-card-other-card": "Other card",
	"delete-button-text": "Delete",
	"saved-card-expired": "Expired {date}",
	"saved-card-removed": "{card} removed",
	"saved-card-expires": "Exp {date}",
	"cancel-button-text": "Cancel",
	"saved-card-pay-with": "Pay with",
	"card-on-file-other-person": "This card will be available for future secure reuse by {name}.",
	"saved-card-unavailable": "That saved card is no longer available. Please enter your card information.",
	"saved-card-list-label": "Saved cards",
	"saved-card-remove-confirm": "Remove this card?",
	"saved-card-remove-failed": "Unable to remove this card. Please try again.",
	"saved-card-remove": "Remove card",
	"saved-card-number-ending-in": "ending in {last4}",
	"saved-card-remove-ending-in": "Remove card ending in {last4}"
};
